<template>
  <main class="ref-page video-page">
    <PageHeader :title="$t('frontend.video.theater')">
      <template #right><router-link to="/Language" class="video-language" :aria-label="$t('frontend.common.change_language')"><van-icon name="globe-o" /></router-link></template>
    </PageHeader>
    <!-- <div class="ref-search"><van-icon name="search" /><input v-model.trim="keyword" :placeholder="$t('frontend.video.search_loaded')" :aria-label="$t('frontend.video.search')"></div> -->
    <!-- <div class="ref-refresh-row"><button class="ref-text-button" :disabled="loading" @click="select(active)">{{ $t('frontend.common.refresh') }}</button></div> -->
    <section class="ref-section">
      <LoadState v-if="loading && !data.length" loading />
      <van-list :loading="loading" :finished="finished || Boolean(keyword)" :error="Boolean(error)" :offset="200"
        :finished-text="finished && data.length && !keyword ? $t('frontend.video.no_more') : ''" @load="load">
        <div v-if="filtered.length" class="ref-video-grid"><VideoCard v-for="item in filtered" :key="item.id || item.vod_id" :item="item" /></div>
        <LoadState v-else-if="!loading && !error" :empty="$t('frontend.video.empty')" />
        <template #loading><LoadState v-if="data.length" loading compact /></template>
        <template #error><LoadState :error="error" :compact="Boolean(data.length)" @retry="load" /></template>
      </van-list>
    </section>
  </main>
</template>
<script>
import PageHeader from "../../common/PageHeader";
import LoadState from "../../common/LoadState";
import VideoCard from "../../common/VideoCard";
import { assertResponse, localizedName, rowsOf } from "../../common/reference";
export default {
  components: { PageHeader, LoadState, VideoCard },
  data: () => ({ active: 888, categoryRows: [], data: [], keyword: "", loading: false, error: "", page: 0, finished: false, requestId: 0 }),
  computed: {
    categories() { return [{ id: 888, name: this.$t('frontend.video.latest') }].concat(this.categoryRows.map(item => ({ id: item.id, name: localizedName(item.name, this.$i18n.locale) }))); },
    filtered() { const value = this.keyword.toLowerCase(); return this.data.filter(item => !value || String(item.vod_name || item.name || "").toLowerCase().includes(value)); }
  },
  methods: {
    select(id) { this.requestId++; this.active = id; this.page = 0; this.data = []; this.finished = false; this.loading = false; this.load(); },
    async load() {
      if (this.loading || this.finished) return;
      const request = ++this.requestId;
      this.loading = true; this.error = "";
      try {
        const result = assertResponse(await this.$http({ method: "get", url: "video_list", data: { id: this.active, page: this.page } }));
        if (request !== this.requestId) return;
        const list = rowsOf(result);
        this.finished = !list.length || (result.last_page !== undefined && this.page + 1 >= Number(result.last_page));
        this.data = this.data.concat(list.filter(item => !this.data.some(old => (old.id || old.vod_id) === (item.id || item.vod_id))));
        this.page++;
      } catch (error) { if (request === this.requestId) this.error = error.message || this.$t('frontend.video.load_failed'); }
      finally { if (request === this.requestId) this.loading = false; }
    },
    async loadCategories() {
      try {
        const result = assertResponse(await this.$http({ method: "get", url: "video_class" }));
        this.categoryRows = rowsOf(result).filter(item => Number(item.id) !== 888);
      } catch (error) { /* The latest category remains usable when categories are unavailable. */ }
    }
  },
  created() { this.loadCategories(); this.load(); },
  beforeDestroy() { this.requestId++; }
};
</script>
<style>
.video-page .ref-header {
  height: 3.3125rem;
  background: #fff;
  color: #282238;
  border-bottom: 0.04rem solid #eeeaf1;
}

.video-page .ref-header__title {
  font-size: 1.125rem;
  line-height: 1.5;
  font-weight: 700;
}

.video-page .video-language {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5625rem;
  height: 3.3125rem;
  margin-right: 0;
  color: #69458f;
  text-decoration: none;
}

.video-page .video-language .van-icon { font-size: 1.25rem; }
.video-page .ref-section { padding: 0.375rem 0.875rem 4.35rem; }
</style>
